module.exports = __webpack_public_path__ + "img/zoom-minus.ae5063be.svg";